import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=3505a381&"
import script from "./Farm.vue?vue&type=script&lang=js&"
export * from "./Farm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports